import { render } from "./App.vue?vue&type=template&id=51421597"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=51421597&lang=css"

import exportComponent from "/Users/mayankmunjal/Desktop/Mayank MS2/major-studio-2-sp24/08-vue-deploy/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__